// pages/Dashboard.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import worker from "../assets/icons/worker.png";
import meter from "../assets/icons/meter.png";
import overview from "../assets/icons/overview.png";

const Dashboard = () => {

  return (
    <div className="dashboard">
      <div className="container">
        <div className="dashboard-header d-flex justify-content-between align-items-center">
          <h3 className="dashboard-header__title">Здесь будет что то</h3>
          <div className="d-flex gap-2 align-items-center">
            <p className="dashboard-header__worker">Jamik | IT</p>
            <div className="dashboard-header__icon"><img src={worker} alt="Иконка пользоватля" /></div>
          </div>
        </div>
        <div className="dashboard-main">
          <div className="row">
            <div className="col-12 col-xs-12 col-sm-4 col-md-3 col-lg-3 col-xl-3">
              <div className="dashboard-main__sidebar">
                <h4 className="sidebar__title">Boshqaruv paneli</h4>
                <ul className="sidebar-list">
                  <li className="sidebar-list__item d-flex align-items-center gap-2">
                    <div className="sidebar-list__icon"><img src={overview} alt="" /></div>
                    <Link className="sidebar-list__link" to="/dashboard/overview">Asosiy</Link>
                  </li>
                  <li className="sidebar-list__item d-flex align-items-center gap-2">
                    <div className="sidebar-list__icon"><img src={meter} alt="" /></div>
                    <Link className="sidebar-list__link" to="/dashboard/add-readings">Pokazaniya qoshish</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-12 col-xs-12 col-sm-8 col-md-9 col-lg-9 col-xl-9">
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

};

export default Dashboard;
